import store from "../store/index"
import {
    mqttConfig
} from "../config/mqttConfig"

import {
    floatFormat
} from "../util/MathUtil"


let client

function createTopics(loopTag) {
    // console.log(loopTag)
    // console.log(store.state.project)
    let db = store.state.project.projectInfo.influxDbName
    // console.log(db)
    return loopTag.map(l => {
        //   console.log(l)
        return `VrMaker/${db}/+/PUBLISH/${l}/#`
    })
}

// ["CX/ZTR14", "",....]
export function subscribe(loopTag) {
    // console.log("subscribe：" , createTopics(loopTag))
    client.subscribe(createTopics(loopTag));
}
export function unsubscribe(loopTag) {
    // console.log(client);
    client.unsubscribe(createTopics(loopTag));
}

function createNodeTopics(nodes) {
    let db = store.state.project.projectInfo.influxDbName
    //   console.log(`VrMaker/${db}/+/PUBLISH/+/+/+/${item}`)
    return nodes.map(item => {
        if (store.state.project.projectInfo.projectId == 4) {
            return `VrMaker/${db}/+/PUBLISH/+/+/+/${item}`
        } else {
            return `VrMaker/${db}/+/PUBLISH/+/+/${item}`
        }
    })
}
export function disconnect() {
    console.log('mqtt断开连接')
    if (client) {
        // client.disconnect()
    }

}
export function subscribeByNodes(nodes) {
    client.subscribe(createNodeTopics(nodes));
}

export function unsubscribeByNodes(nodes) {
    //console.log(client);
    client.unsubscribe(createNodeTopics(nodes));
}

export function subscribeEnvironmentInfo(sensorName) { // sensorName: CH/8to1
    client.subscribe(`VrMaker/${store.state.project.projectInfo.influxDbName}/+/PUBLISH/${sensorName}/#`)
}

export function unsubscribeEnvironmentInfo(sensorName) {
    client.unsubscribe(`VrMaker/${store.state.project.projectInfo.influxDbName}/+/PUBLISH/${sensorName}/#`)
}

export async function connect() {
    // local.vrmaker.vip  192.168.33.176
    client = mqtt.connect(mqttConfig['data'].url, {
        username: mqttConfig['data'].username,
        password: mqttConfig['data'].password,
    });

    await new Promise((resolve, reject) => {
        client.on("connect", () => {
            // console.log("Mqtt connected ...");
            resolve();
        });
    })

    let temp = []

    // 每秒提交一次
    setInterval(() => {
        let list = [].concat(temp)
        temp = []
        store.dispatch("addMqttValList", list)
    }, 2000)

    // client.subscribe('VrMaker/test/123456/PUBLISH/T1/1AA1/#')

    // VrMaker/LT/LT001/PUBLISH/T1/1AA1/XB11/Status_Network 

    client.on("message", (topic, message) => {
        let keys = topic.split('/')
        let len = keys.length
    //   console.log(topic,message.toString())
        let key = ""
        for (let index = 4; index < keys.length; index++) {
            const element = keys[index];
            key += ((index === 4 ? '' : '/') + element)
        }

        //判断所有PFb大于1就等于0
        if (topic.endsWith("PFb") && Number(message) > 1) {
            // console.log(topic, "top");
            message = 0
        }
        if (message.toString() == "True" || message.toString() == "False") {
            store.commit("addMqttVal", {
                key,
                val: floatFormat(Number(message), 3)
            })
        } else {
            // console.log(222)
            temp.push({
                key,
                val: floatFormat(Number(message), 3)
                //  val: message.toString()

            })
        }

    });

}